import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy-next",
  "use": "icon-copy-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-copy-next\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 9L5 19H15H17C17 20.1046 16.1046 21 15 21H5C3.89543 21 3 20.1046 3 19V9C3 7.89543 3.89543 7 5 7V9Z\" fill=\"currentColor\" />\n<path d=\"M8 5H18C18.5523 5 19 5.44772 19 6V16C19 16.5523 18.5523 17 18 17H8C7.44772 17 7 16.5523 7 16V6C7 5.44772 7.44772 5 8 5Z\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol